// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"964f8be1","131":"f1e95b4e","323":"4ec330bb","468":"dfab11ae","851":"ea3c4535"}[chunkId] + ".chunk.js";
};